import React, {useEffect, useState} from "react";
import {Alert, Modal, Table, Tabs} from "antd";
import {FlatEditsService} from "../../../../../shared/api/flatEdits/flatEdits.service";
import "./FlatEdits.scss";

// ECI old's «Просмотреть изменения» (snippet showEdits, chunks editsTable / editsTableRow): the flat's changes, newest
// first — the date, the employee, «Поле: (откуда)» and «"было" -> "стало"»; and the history of its statuses of
// actualization. The server keeps both (backend service/flatEdits.service.js), ECI old's rows with them.
const PAGE = 500

// «02.12.2023 в 00:20:43», Moscow time
const momentOf = (at) => new Date(at).toLocaleString('ru-RU', {timeZone: 'Europe/Moscow'}).replace(', ', ' в ')
const dayOf = (date) => (date ? String(date).slice(0, 10).split('-').reverse().join('.') : '')

const COLUMNS = [
  {title: 'Дата', dataIndex: 'at', width: 170, render: momentOf},
  {title: 'Пользователь', dataIndex: 'user', width: 200},
  {title: 'Изменения', key: 'change', render: (_, row) => (
    <div className='flat-edits__change'>
      <b>{row.field}:</b>{row.source ? ` (${row.source})` : ''}
      <div>"{row.oldValue}" -&gt; "{row.value}"</div>
    </div>
  )},
]

export const FlatEdits = ({apartmentId, onClose}) => {
  const [data, setData] = useState(null)
  const [page, setPage] = useState(1)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const load = async (current) => {
    setLoading(true)
    setError(null)
    try {
      const {data: answer} = await FlatEditsService.fetch(apartmentId, (current - 1) * PAGE)
      setData(answer)
      setPage(current)
    } catch (e) {
      setError(e?.response?.data?.errors?.message || 'Не удалось загрузить изменения')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    load(1)
    // eslint-disable-next-line
  }, [apartmentId])

  const statuses = data ? data.statuses : []
  return (
    <Modal visible title={`Изменения квартиры ID ${apartmentId}`} width={Math.min(1000, window.innerWidth)} footer={null}
      onCancel={onClose} className='flat-edits'>
      {error && <Alert type='error' message={error}/>}
      <Tabs defaultActiveKey='edits'>
        <Tabs.TabPane tab={`Изменения${data ? ` (${data.total})` : ''}`} key='edits'>
          <Table rowKey='id' size='small' columns={COLUMNS} dataSource={data ? data.items : []} loading={loading}
            locale={{emptyText: 'Изменений нет'}}
            pagination={data && data.total > PAGE
              ? {current: page, pageSize: PAGE, total: data.total, showSizeChanger: false, onChange: load}
              : false}/>
        </Tabs.TabPane>
        <Tabs.TabPane tab={`История статусов${data ? ` (${statuses.length})` : ''}`} key='statuses'>
          {statuses.length
            ? <ul className='flat-edits__statuses'>{statuses.map((s, i) => <li key={i}>{dayOf(s.date)} - {s.status || '—'}</li>)}</ul>
            : !loading && <p>Статусов нет</p>}
        </Tabs.TabPane>
      </Tabs>
    </Modal>
  )
}
